/* Component Dependencies */
var hwsBreadcrumbsTemplate = require('templates/hwsBreadcrumbs.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');
var _ = require('lodash');

AriesComponent.create({  
  type: 'hwsBreadcrumbs',  
  template: {
		'hwsBreadcrumbs': hwsBreadcrumbsTemplate
  },
  events: {
		'click .breadcrumb-host-name': 'toggleMainNav'
  },
  toggleMainNav: function(evt){
  	evt.preventDefault();
  	$('.js-toggle-menu .m-hamburger-menu')[0].click();
  	var hostName = _.escape($('.breadcrumb-host-name').attr("data-host-name"));
  	if($('.l-overlay-container h3.m-bread-crumb-header').length == 0){
  			$('<h3 class="m-bread-crumb-header">'+hostName+'</h3>').insertBefore('ul.l-header-navigation');
  	}
  }
});
